import { Component, ElementRef, Injector, Type } from "@angular/core";
import { trigger, state, animate, transition, style } from "@angular/animations";
import { BfxLadderOrdersContextMenuService } from "./bfx-ladder-orders-contextmenu.service";

import { BfxBlotterOrdersContextMenu } from "../bfx-blotter-orders/bfx-blotter-orders-contextmenu";

import { OrderDataPrimaryLookupService } from "shared/cubiq-services";

import { LoggerService } from "@bfx/logger";

const logger = LoggerService.for(__dirname);

@Component({
  selector: "bfx-ladder-orders-context-menu",
  templateUrl: "../bfx-blotter-orders/bfx-blotter-orders-contextmenu.html",
  animations: [
    trigger("showHideMenu", [
      state("show", style({ opacity: 1 })),
      state("hide", style({ opacity: 0 })),
      transition("show => hide", animate("100ms ease-in")),
      transition("hide => show", animate("100ms ease-out")),
    ]),
  ],
  standalone: false,
})
export class BfxLadderOrdersContextMenu extends BfxBlotterOrdersContextMenu {
  constructor(
    injector: Injector,
    lookupService: OrderDataPrimaryLookupService,
    elementRef: ElementRef,
  ) {
    super(injector, lookupService, elementRef);
  }

  protected getMenuServiceType(): Type<BfxLadderOrdersContextMenuService> {
    return BfxLadderOrdersContextMenuService;
  }
}
